import React, { useEffect, useState } from 'react';
import usePortalAuth from '../../../auth/usePortalAuth';

import { Form, FormGroup, Input, ModalBody } from 'reactstrap';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import classnames from 'classnames';
import { createTheme, MuiThemeProvider, withStyles, makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTour } from '@reactour/tour';

import basePCUrl from '../../../Globals';

import useForm from '../CustomHooks/useForm';
import Error from '../Error/Error';
import { set } from 'date-fns';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: 12,
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
      minWidth: 500,
    },
  },
  dialogTitle: {
    background: 'linear-gradient(135deg, #0a1e42 0%, #0b5fad 50%, #3a8ac4 100%)',
    color: 'white',
    padding: '16px 24px',
    textAlign: 'center',
    margin: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
  modalBody: {
    padding: theme.spacing(4),
  },
  title: {
    textAlign: 'center',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 700,
    color: '#061739',
    marginBottom: theme.spacing(3),
  },
  formControl: {
    marginBottom: theme.spacing(2.5),
    width: '100%',
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'rgba(0, 85, 162, 0.3)',
      },
      '&:hover fieldset': {
        borderColor: '#0055A2',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#0055A2',
      },
    },
  },
  submitButton: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600,
    fontSize: '0.9rem',
    textTransform: 'none',
    marginTop: theme.spacing(2),
    backgroundColor: '#0055A2',
    color: '#fff',
    padding: theme.spacing(1.5),
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#003d75',
      boxShadow: 'none',
    },
  },
  errorMessage: {
    textAlign: 'center',
    color: '#F44336',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
    background: 'rgba(244, 67, 54, 0.1)',
    borderRadius: 8,
  },
  switchLabel: {
    marginTop: theme.spacing(1),
  },
  triggerButton: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600,
    fontSize: '0.85rem',
    textTransform: 'none',
    backgroundColor: '#0055A2',
    color: '#fff',
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#003d75',
      boxShadow: 'none',
    },
  },
  successView: {
    textAlign: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  successIcon: {
    color: '#4CAF50',
    fontSize: '3.5rem',
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  successText: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 700,
    fontSize: '1.1rem',
    color: '#061739',
    marginBottom: theme.spacing(3),
  },
  addAnotherButton: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600,
    fontSize: '0.9rem',
    textTransform: 'none',
    borderColor: '#0055A2',
    color: '#0055A2',
    padding: theme.spacing(1.2, 2.5),
    borderRadius: 8,
    marginRight: theme.spacing(2),
  },
  doneButton: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600,
    fontSize: '0.9rem',
    textTransform: 'none',
    backgroundColor: '#0055A2',
    color: '#fff',
    padding: theme.spacing(1.2, 2.5),
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#003d75',
      boxShadow: 'none',
    },
  },
}));

const UserManagementModal = (props) => {
  const classes = useStyles();
  const [errorMessage, setErrorMessage] = useState('errorMessage');
  const [invalidEmail, setInvalidEmail] = useState('');
  const [refreshUserList, setRefreshUserList] = useState('');

  const [loadingAddedUsers, setLoadingAddedUsers] = useState(false);
  const [successState, setSuccessState] = useState(false);

  const { getAccessTokenSilently, logout } = usePortalAuth();

  // Clean up PCAT DOM element and perform logout
  const handleLogout = () => {
    // Clear localStorage items related to user session
    localStorage.removeItem('usid');
    // Perform provider logout
    logout({
      returnTo: 'https://portal.phishcloud.io/PortalSignIn',
    });
  };
  const { values: email, bind: bindEmail, reset: resetEmail } = useForm('');
  const { values: accessLevel, bind: bindAccessLevel, reset: resetAccessLevel } = useForm('');

  const [emailTypeToggle, setEmailTypeToggle] = useState(false);
  const [emailType, setEmailType] = useState();

  const clientId = props.clientId;
  const preferredLanguage = props.preferredLanguage
  const getTranslation = props.getTranslation

  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
    setSuccessState(false);
    setLoadingAddedUsers(false);
    setErrorMessage('');
    resetEmail();
    resetAccessLevel();
  };

  const toggleClose = () => {
    setModal(!modal);
    setSuccessState(false);
    setRefreshUserList('');
    setErrorMessage('');
  };

  const handleDone = () => {
    setModal(false);
    setSuccessState(false);
    setLoadingAddedUsers(false);
    setRefreshUserList('');
    setErrorMessage('');
    if (clientId !== undefined) {
      props.retrieveUsers(clientId);
    } else {
      props.retrieveUsers('');
    }
  };

  const handleAddAnother = () => {
    setSuccessState(false);
    setLoadingAddedUsers(false);
    resetEmail();
    resetAccessLevel();
    setErrorMessage('');
    setInvalidEmail('');
  };

  const changeEmailSendTypeSwitch = () => {
    setEmailTypeToggle(!emailTypeToggle);
  };

  useEffect(() => {
    emailTypeToggle ? setEmailType('gpo') : setEmailType('manual');
  }, [emailTypeToggle]);

  //----------------Send Activations/Resend Activations---------------//

  const sendActivationsToUsers = async () => {
    const token = await getAccessTokenSilently();

    var data = {
      listOfEmails: [email],
    };

    fetch('UserManagement/EmailUserActivationInstructions', {
      credentials: 'same-origin',
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);

          return;
        }
        response.json().then((data) => {
          if (data.status === 'Not Authorized') {
          } else if (data.status === 'Error') {
          } else {
            return;
          }
        });
      })
      .catch(function (err) {
        console.log('Fetch Error :-S', err);
      });
  };

  //------------Add Uesr-------------//
  const handleSubmit = async (event) => {
    event.preventDefault();
    const token = await getAccessTokenSilently();

    let check =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    //if (clientId !== undefined) {

    var data = {
      clientId: clientId,
      //props.clientId,
      installMethod: emailType,
      listOfEmails: [email],
      //.toLowerCase()],
      listOfAccessLevels: [accessLevel],
    };

    //}

    // else {
    //     var data =
    //     {
    //         clientId: "",
    //         //props.clientId,
    //         installMethod: emailType,
    //         listOfEmails: [email],
    //         //.toLowerCase()],
    //         listOfAccessLevels: [accessLevel],
    //     };
    // }

    if (check.test(email)) {
      setSuccessState(true);
      fetch(basePCUrl, {
        method: 'POST',
        headers: {
          action: 'createPhishCloudUser',
          'content-type': 'application/json',
          id: clientId,
          //testacct: uid,
          //uid,
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (response.status !== 200) {
            console.log('Looks like there was a problem. Status Code: ' + response.status);
            return;
          }

          response.json().then((data) => {
            const entries = Object.entries(data);
            if (!entries.toString().includes('successfully added')) {
              setLoadingAddedUsers(false);
            }
            setErrorMessage(entries);

            // console.log(data.status);
            // setErrorMessage(data.status);
            // if (!data.status.includes("Duplicate Emails")) {
            //     sendActivationsToUsers();
            // }
            //setTimeout(props.retrieveUsers(props.uid, props.clientId), 200);
          });
        })
        .catch(function (err) {
          console.log('Fetch Error :-S', err);
        });
    } else {
      setLoadingAddedUsers(false);
      setInvalidEmail('That is an invalid email address.');
      return console.log('That is not a valid email address');
    }
  };

  useEffect(() => {

    if (errorMessage.includes('duplicate email')) {
      displayErrorMessage();
    } else if (errorMessage.toString().includes('successfully added')) {
      setSuccessState(true);
    } else if (errorMessage.toString().includes('failed to add')) {
      toggleClose();
      Error();
    } else if (errorMessage.includes('not able to verify access token or resolve to a valid user')) {
      handleLogout();
    }
  }, [errorMessage]);

  const displayErrorMessage = () => {
    if (errorMessage != null && errorMessage.toString().includes('duplicate email')) {
      return (
        <p className={classes.errorMessage}>
          {getTranslation('Oops!', preferredLanguage)} <b>{email}</b> {getTranslation('is already in our system. Please contact support@phishcloud.com if you think this is a mistake', preferredLanguage)}.
        </p>
      );
    }
  };

  const displayInvalidEmailMessage = () => {
    if (invalidEmail != '') return <p className={classes.errorMessage}>{invalidEmail}</p>;
  };

  const DialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.dialogTitle} style={{ position: 'relative' }} {...other}>
        <Typography variant="h6" style={{ color: 'white', fontFamily: 'Montserrat, sans-serif', fontWeight: 700 }}>
          {children}
        </Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  };

  //-----User Modal close button toggle-----//
  const closeBtn = (
    <Button outline color="white" onClick={toggleClose}>
      <FontAwesomeIcon icon={['fas', 'times']} size="lg" />
    </Button>
  );

  return (
    <div>
      <Button
        variant="contained"
        className={classes.triggerButton}
        startIcon={<FontAwesomeIcon icon={['fas', 'plus-square']} />}
        onClick={toggle}
      >
        {getTranslation('Add Single User', preferredLanguage)}
      </Button>

      <Dialog className={classes.dialog} onClose={toggle} aria-labelledby="customized-dialog-title" open={modal}>
        <DialogTitle id="customized-dialog-title" onClose={toggle}>
          {successState ? getTranslation('User Added!', preferredLanguage) : getTranslation('Add a User', preferredLanguage)}
        </DialogTitle>

        <div className={classes.modalBody}>
          {successState ? (
            <div className={classes.successView}>
              <div className={classes.successIcon}>✓</div>
              <Typography className={classes.successText}>
                {getTranslation("We've submitted that user, check back in a minute.", preferredLanguage)}
              </Typography>
              <div>
                <Button variant="outlined" className={classes.addAnotherButton} onClick={handleAddAnother}>
                  {getTranslation('Add Another User', preferredLanguage)}
                </Button>
                <Button variant="contained" className={classes.doneButton} onClick={handleDone}>
                  {getTranslation("I'm Done", preferredLanguage)}
                </Button>
              </div>
            </div>
          ) : (
            <Form id="addUserForm" onSubmit={handleSubmit}>
              {displayErrorMessage()}
              {displayInvalidEmailMessage()}

              <FormControl className={classes.formControl}>
                <TextField
                  type="email"
                  name="email"
                  placeholder="User Email"
                  required
                  label="Email"
                  variant="outlined"
                  className={classes.textField}
                  {...bindEmail}
                />
              </FormControl>

              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel>{getTranslation('Access Level', preferredLanguage)}</InputLabel>
                <Select
                  {...bindAccessLevel}
                  id="demo-simple-select-outlined"
                  required
                  name="accessLevel"
                  label="Access Level"
                  className={classes.textField}
                >
                  <MenuItem value="">{getTranslation('Access Level', preferredLanguage)}</MenuItem>
                  <MenuItem value="User">{getTranslation('User', preferredLanguage)}</MenuItem>
                  <MenuItem value="CompanyAdmin">{getTranslation('Company Admin', preferredLanguage)}</MenuItem>
                </Select>
              </FormControl>

              <FormControlLabel
                className={classes.switchLabel}
                control={
                  <Switch
                    checked={emailTypeToggle}
                    onChange={changeEmailSendTypeSwitch}
                    name="emailTypeToggle"
                    color="primary"
                  />
                }
                label="Use GPO set up for this user"
              />

              <Button
                type="submit"
                fullWidth
                className={classes.submitButton}
                onClick={() => setRefreshUserList(true)}
              >
                {getTranslation('Add', preferredLanguage)}
              </Button>
            </Form>
          )}
        </div>
      </Dialog>
    </div>
  );
};
export default UserManagementModal;

//< Modal isOpen = { modal } toggle = { toggle } >
//    <ModalHeader toggle={toggle} close={closeBtn}></ModalHeader>

//< Modal isOpen = { modal } toggle = { toggle } >
//    <ModalHeader toggle={toggle} close={closeBtn}></ModalHeader>
//    <ModalBody>
//        <h1 className="userManagementModalLabel">Add a User</h1>
//        <br></br>

//        <Form id="addUserForm" onSubmit={handleSubmit}>

//            {displayErrorMessage()}
//            {displayInvalidEmailMessage()}

//            <div className="ModalForm">

//                <FormGroup style={{ fontSize: '12px', alignContent: 'center', alignItems: 'center' }} >
//                    <Input type="email" name="email" placeholder="User Email" required {...bindEmail} />
//                </FormGroup>

//                <FormGroup style={{ fontSize: '12px', marginLeft: '0px', alignContent: 'center', alignItems: 'center' }} >
//                    <Input type="select" required name="accessLevel" {...bindAccessLevel} style={{ marginLeft: '0px' }}>
//                        <option disabled selected value="">Access Level</option>
//                        <option value="User">User</option>
//                        <option value="CompanyAdmin">CompanyAdmin</option>
//                    </Input>

//                </FormGroup>

//            </div>

//            <div className='addUserButton'>
//                <Button type="submit" onClick={() => setRefreshUserList(true)} size="lg" color="primary" block >Add</Button>{' '}
//            </div>
//        </Form>

//    </ModalBody>
//        </Modal >
